<template>
  <div
    id="app"
    :class="{
      container: true,
      'has-navbar-fixed-top': this.$store.getters.islogged
    }"
  >
    <caxton-nav v-if="this.$store.getters.islogged"></caxton-nav>
    <router-view />
  </div>
</template>
<script>
import CaxtonNav from "@/components/CaxtonNav";
export default {
  components: { CaxtonNav },
  data: function() {
    return {};
  },

  mounted() {
    if (this.$auth.token() && !this.$store.getters.islogged) {
      console.log("[App] hay token y no logged");
      this.$store.commit("SET_ISLOGGED", true);
      if (this.$route.name == "Login") {
        this.$router.push({ name: "Rutas" });
      }
    }
    if (
      this.$store.getters.maininfo.monitores.length == 0 &&
      this.$store.getters.islogged
    ) {
      this.$store.dispatch("GET_INFO");
    }
  }
};
</script>

<style lang="scss"></style>
